export const FormFields = {
  INVOICING_EMAIL: 'invoicingEmail',
  VAT_NUMBER: 'vatNumber',
};
